import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useSelectDefaultDaysOfWeek = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
): ((dayOfWeek: DayOfWeekType, index: number, type: StockUnionType | '') => void) => {
  return useCallback(
    (dayOfWeek: DayOfWeekType, index: number, type: StockUnionType | '') => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState
        const dayOfWeeks = prevState[index].days_of_week
        // すでにリスト内にあれば削除、なければ追加
        if (dayOfWeeks.includes(dayOfWeek)) {
          const nextDayOfWeeks = dayOfWeeks.filter((_dayOfWeek) => _dayOfWeek !== dayOfWeek)
          nextState[index].days_of_week = [...nextDayOfWeeks]
        } else {
          nextState[index].days_of_week = [...dayOfWeeks, dayOfWeek]
        }
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useSelectDefaultDaysOfWeek
